import { createColumnHelper } from '@tanstack/react-table';
import './util-styles/text-styles.css';
import SigniteButton from '../components/ui-elements/signite-button/signiteButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { CandidateService } from '../services/candidateService';
import { isArray } from 'lodash';
import { decodeJWT } from '../services/candidateService';
export const prepareAssignCandidateData = (candidateData, handleShow) => {
  const data = candidateData && candidateData.data && candidateData.data.candidates;

  const columnHelper = createColumnHelper();

  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const currentUserRole = decoded?.roles;

  const downloadFile = (resumePath, fileName) => {
    CandidateService.downloadResume(encodeURI(resumePath))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // Replace with the desired file name and extension
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error(err));
  };
  const columns = [
    columnHelper.accessor((row) => row.candidateId || Math.random() + "str", {
      id: 'candidateId',
      cell: (info) => (
        <a href={`/candidate/candidate-personal-info?candidateId=${info.getValue()}`}>{info.getValue()}</a>
      ),
      header: () => <span>Candidate ID</span>,
    }),
    columnHelper.accessor('candidate.personalDetails.firstName', {
      id: 'candidate.personalDetails.firstName',
      cell: (info) => (
        <div
          className="truncate"
          style={{ maxWidth: 220 }}
          data-tooltip-id="my-tooltip1"
          data-tooltip-content="Hello to you too!"
        >
          {info.getValue()}
        </div>
      ),
      header: () => <span>First Name</span>,
    }),
    ,
    columnHelper.accessor('candidate.personalDetails.lastName', {
      header: () => 'Last Name',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor('candidate.personalDetails.primaryPhoneNumber', {
      header: () => 'Phone Number',
      cell: (info) => info.renderValue(),
    }),
    columnHelper.accessor('candidate.workExperience.currentRole.designation', {
      header: () => 'Designation',
      cell: (info) => info.renderValue(),
    }),
    columnHelper.accessor('candidate.personalDetails.primaryEmailId', {
      header: () => 'Email Id',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor('candidate.personalDetails.resume', {
      header: () => 'Resume',
      cell: (info) => {
        const resume = info.getValue() && isArray(info.getValue()) ? info.getValue()[0] : null;
        console.log(resume)
        return (
          resume ?
            <div className="truncate" style={{ maxWidth: 220 }}>
              <a
                href="#"
                className="resetLinkStyle candidateCVDownload"
                onClick={() => {
                  downloadFile(
                    _.get(resume, 'path'),
                    _.get(resume, 'originalName')
                  );
                }}
              >
                Download CV <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
              </a>
              {//info.getValue()
              }
            </div> : ""
        )
      },
    }),
  ];
  if (currentUserRole !== 'DATA_ENTRY_EXE') {
    columns.push(
      columnHelper.accessor((row) => row.candidateId, {
        header: () => 'Assign To',
        id: 'candidateId_assignedUser',
        cell: (info) => (
          <div className="truncate" >
            <SigniteButton
              variant={'primary'}
              onClick={() => handleShow(_.get(info, 'row.original.candidateId'))}
            >
              {_.get(info, 'row.original.assignedTo.username') || 'Assign'}
            </SigniteButton>
          </div>
        ),
      })
    );
  }

  return { columns, data };
};
